import Scott from "./Scott";
import Nerko from "./Nerko";

export const Templates = {
  Scott,
  Nerko,
};